import type { LucideIcon } from 'lucide-react'
import {
	Car,
	Cloud,
	File,
	FileSpreadsheet,
	FileText,
	Globe,
	KeyRound,
	Languages,
	Mail,
	MessageSquare,
	Palette,
	Paperclip,
	Send,
	Shield,
	Star,
} from 'lucide-react'
import {
	type CustomPageIcon,
	CustomPageIcon as CustomPageIconEnum,
} from '@/generated/api/backstage.schemas/customPageIcon'

export const customPageIconMap: Record<CustomPageIcon, LucideIcon> = {
	[CustomPageIconEnum.FILEICON]: File,
	[CustomPageIconEnum.FILEWORDICON]: FileText,
	[CustomPageIconEnum.FILEEXCELICON]: FileSpreadsheet,
	[CustomPageIconEnum.PAPERPLANEICON]: Send,
	[CustomPageIconEnum.PAPERCLIPICON]: Paperclip,
	[CustomPageIconEnum.PALETTEICON]: Palette,
	[CustomPageIconEnum.GLOBEICON]: Globe,
	[CustomPageIconEnum.STARICON]: Star,
	[CustomPageIconEnum.CLOUDICON]: Cloud,
	[CustomPageIconEnum.COMMENTSICON]: MessageSquare,
	[CustomPageIconEnum.KEYICON]: KeyRound,
	[CustomPageIconEnum.ENVELOPEICON]: Mail,
	[CustomPageIconEnum.SHIELDICON]: Shield,
	[CustomPageIconEnum.LANGUAGEICON]: Languages,
	[CustomPageIconEnum.CARICON]: Car,
}

export function getCustomPageIconComponent(iconId: string): LucideIcon {
	return customPageIconMap[iconId as CustomPageIcon] ?? File
}
